import { Injectable } from '@angular/core';
import 'rxjs/add/operator/map';
import { Souscripteur } from '../models/souscripteur.model';
import { Observable } from 'rxjs/Observable';
import Api from '../../common/services/api.service';


@Injectable()
export class SouscripteurServiceClient {
    private endpoint = 'client/souscripteurs/';

    constructor(private api: Api) { }
    getSouscripteur(id: string): Observable<Souscripteur> {
         return this.api.get(this.endpoint + id);
    }

}



// WEBPACK FOOTER //
// ./src/app/client-app/services/souscripteur.service.ts